<template>
    <!-- 监听滚动 -->
    <div ref="scrollbar" class="scrollbar-container">
        <slot></slot>
    </div>
</template>

<script>
// 用于使用keep-alive缓存页面时保持滚动条位置
export default {
    props: {
        // 是否缓存页面信息
        // 为true时会缓存滚动条信息
        isKeep: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            yPosition: 0
        };
    },
    mounted() {
        if (this.isKeep) {
            // console.log('addEventListener')
            this.$refs.scrollbar.addEventListener(
                "scroll",
                this.paperScroll,
                false
            );
        }
    },

    beforeDestroy() {
        if (this.isKeep) {
            // console.log('removeEventListener')
            // 销毁监听事件
            document.removeEventListener("scroll", this.paperScroll, false);
        }
    },
    activated() {
        if (this.isKeep) {
            // 页面激活时设置当前滚动位置
            // console.log("activated", this.yPosition);
            this.$refs.scrollbar.scrollTop = this.yPosition;
        }
    },
    methods: {
        // 监听滚动获取滚动位置
        paperScroll(item) {
            this.yPosition = item.srcElement.scrollTop;
            // console.log("yPosition", this.yPosition);
        }
    }
};
</script>